export default {
    lang: 'عربي',
    'company-login': 'Company login',
    'forsa-title': 'Forsa Sell and Barter',
    'forsa-about': 'Forsa simplifies buying, selling, and bartering <br> with comprehensive, cutting-edge technological solutions',

    "footer": {
		"links": {
			"about-us": "About US",
			"about-forsa": "About Forsa",
			"our-vision": "Our Vision",
			"our-mission": "Our Mission",
			"our-message": "Our Message",
			"faqs": "FAQs",
			"policies": "Policies",
			"contact-details": "Contact Details",
			"safety-and-security": "Safety and Security",
			"how-does-it-work?": "How Does It Work?",
			"terms-conditions": "Terms & Conditions",
			"privacy-policy": "Privacy Policy",
            "contact-us": "Contact Us"
		},
		"copyrights": "Copyright {year} © Forsa Barter. All rights reserved"
	},
}

